import { SyncOutlined } from "@ant-design/icons";
import { Button, Card, Space, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonComponent from "../fields/ButtonComponent";
import SearchComponent from "../fields/SearchComponent";
import SwalComponent from "../fields/SwalComponent";
import TableComponent from "../fields/TableComponent";
import { MobileClientStatus, deleteMobileClient, getMobileClientList } from "../store/reducer/mobileClient";
import PageHeader from "../view/pageheader";
import moment from "moment";
import Loader from "../fields/loader/Loader";
import { UnorderedListOutlined } from '@ant-design/icons';

const MobileClients = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //Selectors
    const {
        clientListData,
        clientListLoading,
        deleteClientLoading,
        deleteClientSuccess,
        deleteClientError,
        deleteClientErrorMessage,
        clientStatusLoading,
        clientStatusSuccess,
        clientStatusError,
        clientStatusErrorMessage,
    } = useSelector(state => state.mobileClient);
    const roleID = localStorage.getItem('role_id')
    const category_type = localStorage.getItem('category_type')
    const [statusType] = useState({
        1: "Active",
        0: "Inactive",
    });

    console.log(clientListData, 'clientListData');

    const { count: totalCount, data: tableData } = clientListData;

    function getData(payload = {}) {
        dispatch(getMobileClientList(payload));
    }

    useEffect(() => {
        getData({});

        if (deleteClientSuccess) {
            toast.success("Client deleted successfully");
        }

        if (deleteClientError) {
            toast.error(deleteClientErrorMessage);
        }

        if (clientStatusSuccess) {
            toast.success("Client status updated successfully");
        }

        if (clientStatusError) {
            toast.error(clientStatusErrorMessage);
        }
    }, [deleteClientError, deleteClientSuccess, clientStatusError, clientStatusSuccess]);

    const columns = [
        {
            title: "Mobile Client ID",
            key: "mobile_client_number",
            align: "center",
            render: record => (
                <Link to={`/mobile/editclient/${btoa(record?.id)}`}>
                    <span>{record.mobile_client_number}</span>
                </Link>
            ),
            sorter: true,
        },
        {
            title: "Last Name",
            dataIndex: "last_name",
            key: "last_name",
            align: "center",
            sorter: true,
        },
        {
            title: "City",
            dataIndex: "city",
            key: "city",
            align: "center",
            sorter: true,
        },
        {
            title: "State",
            dataIndex: "state",
            key: "state",
            align: "center",
            sorter: true,
        },
        {
            title: "Status",
            key: "client_status",
            align: "center",
            render: record => {
                console.log(record, 'record');

                if (roleID === '2' && category_type === '3') {
                    return <span>{statusType[record.client_status]}</span>
                }
                else {
                    return <SwalComponent
                        message="Are you sure you want to change the client status?"
                        onClickDispatch={MobileClientStatus}
                        id={record.id}
                        status={true}
                        statusValue={record.client_status}
                        postData={{ client_status: record.client_status === 1 ? 0 : 1 }}
                    />
                }
            }
            ,
            sorter: true,
        },
        {
            title: "Created",
            key: "created_at",
            align: "center",
            render: record => (
                <span>
                    {" "}
                    {moment(record?.created_at).format("MM/DD/YY")}
                </span>
            ),
            sorter: true,
        },
        {
            title: "Current Plan",
            key: "current_plan",
            align: "center",
            sorter: true,
        },
        {
            title: "Plan Validity",
            key: "plan_end_date",
            align: "center",
            render: record => (
                <span>
                    {" "}
                    {moment(record?.plan_end_date).format("MM/DD/YY")}
                </span>
            ),
            sorter: true,
        },
        ...(roleID === '2' && category_type === '3' ? [] : [
            {
                title: "Action",
                align: "center",
                render: (record) => {
                    return (
                        <Space size="large" align="center">
                            <span className="fs-6" style={{ color: "blue", cursor: "pointer" }}>
                                <Tooltip title="Edit">
                                    <i
                                        className="icon-pencil"
                                        onClick={() => {
                                            console.log(record, "record");
                                            navigate(`/mobile/editclient/${btoa(record?.id)}`);
                                        }}
                                    ></i>
                                </Tooltip>
                            </span>
                            <SwalComponent
                                message="Are you sure you want to delete the client?"
                                onClickDispatch={deleteMobileClient}
                                id={record.id}
                            />
                        </Space>
                    );
                },
            },
        ])
    ];

    return (
        <div>
            <Loader loading={clientListLoading || deleteClientLoading || clientStatusLoading} />
            <div className="container-fluid">
                <PageHeader
                    HeaderText="Mobile Clients Management"
                    Breadcrumb={[{ name: "Clients Management" }]}
                    backButtonUrl={`/clients`}
                />
                <Card
                    title="Mobile Clients List"
                    extra={
                        <Space size={"middle"} className="my-3">
                            {/* <Link to={`/project/item-categories/${id}/${clientID}`}> */}
                            <Link to="/mobile/item-categories">
                                <ButtonComponent
                                    style={{ backgroundColor: "#f7931e", color: "white" }}
                                    buttonName="Mobile Item categories"
                                    icon={<UnorderedListOutlined />}
                                />
                            </Link>
                            <SearchComponent
                                placeHolder="Search Mobile Client"
                                onChange={e => {
                                    const payloadData = {
                                        query: e.target.value,
                                    };
                                    getData(payloadData);
                                }}
                            />
                            {roleID === '2' && category_type === '3' ? null :
                                <Link to="/mobile/addclient">
                                    <ButtonComponent
                                        style={{ backgroundColor: "#f7931e", color: "white" }}
                                        buttonName="Add Mobile Client"
                                        icon={<i className="fa fa-user-plus" aria-hidden="true"></i>}
                                    />
                                </Link>}
                        </Space>
                    }
                >
                    <TableComponent
                        columns={columns}
                        dataSource={tableData}
                        TotalDataCount={totalCount}
                        onChangeDispatch={getData}
                    />
                </Card>
            </div>
        </div>
    );
};

export default MobileClients;